import React from 'react';

const hero = (data) => {
	return (
		<div
			className="banner mon-bg-800h"
			style={{
				backgroundImage: data.checkout_v3_hero_backgroundImg ? `url(${data.checkout_v3_hero_backgroundImg})` : null,
			}}
		>
			<div className="overlay" style={{ backgroundColor: data.checkout_v3_hero_overlayColor }}></div>
			<div className="banner__content">
				<h1 className="banner__header" style={{ color: data?.checkout_v3_hero_textColor }}>
					{data.tr_checkout_v3_hero_heading}
				</h1>
				<div style={{ maxWidth: `${data.checkout_v3_hero_imgWidth}px` }}>
					<img
						src={data.checkout_v3_hero_productImg}
						style={{ width: '100%', height: '100%' }}
						className="mon-img-320-h"
					/>
				</div>
			</div>
		</div>
	);
};

export default hero;
